import {createContext} from "react";

export const JournalEditableScorecardContext = createContext(null)